import React, { useContext } from 'react';
import styled from 'styled-components';
import TileButton from '../components/TileButton';
import ToggleSwitch from '../../../../FormStyles/ToggleSwitch';
import i18n from '../../../../../app/i18n';
import { InteractionContext } from '../../../contexts';

const Feedback = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <>
      {values.answers.map((answer, i) => (
        <TileButton
          key={`feedback_button_${i}`}
          buttonText={answer}
          buttonIndex={i}
          onChangeButtonText={handleChange}
        />
      ))}
      <ToggleWrapper>
        <ToggleSwitch
          value={values.isAnonymous}
          onChange={handleChange}
          name="isAnonymous"
          id="isAnonymous"
          label={i18n.t('tileForm:interaction.toggleLabels.makeTileAnonymous')}
          color="black.80"
          fontWeight="400"
          margin="0 0 10px 0"
          invertLabelPosition
        />
      </ToggleWrapper>
    </>
  );
};

export default Feedback;

const ToggleWrapper = styled.div`
  margin: 10px 0;
`;
